import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ApiconfigService } from '../apiconfig/apiconfig.service';
import { USERDEFINEDAPI } from '../apiconfig/model/apiConfig.model';
import { MatChipOption } from '@angular/material/chips';
import { APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from '../../constants/proj.cnst';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'lib-api-calls',
  templateUrl: './api-calls.component.html',
  styleUrls: ['./api-calls.component.scss']
})
export class ApiCallsComponent implements OnInit{

  constructor(private apiconfigService:ApiconfigService,private toastrSrv:ToastrService){}

 apis!:any[];
 authApis!:any[];
 panelOpenState!:boolean;
 currentSelectedApi!:USERDEFINEDAPI  | null;
 currentSelectedChip:any;
 @ViewChildren('chipAuthApiOption') authApiChipOptions!: QueryList<MatChipOption>;
 @ViewChildren('chipApiOption') apiChipOptions!: QueryList<MatChipOption>;

  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;

  async ngOnInit() {
    await this.apisListSetter();  
    this.chipSelectionSetter();
  }

  chipSelectionSetter(){
    this.apiconfigService.selectedApi$.subscribe((selectedApiEvent:any) => {
      if(selectedApiEvent.event !== 'redirect'){
        return;
      }
      this.currentSelectedApi = selectedApiEvent.apiData;
      console.log(this.currentSelectedApi, 'api data')
      if(selectedApiEvent.authApi){
        let index = this.authApis.findIndex((api:USERDEFINEDAPI) => api.apiId === selectedApiEvent.apiData.apiId) ;
        
        const newAddedApi = this.authApiChipOptions.toArray()[index];
        if(newAddedApi){
          console.log(newAddedApi);
          setTimeout(() => {
            this.authApiChipOptions.toArray()[index].select();
          },200)
        }
      }else{
        let index = this.apis.findIndex((api:USERDEFINEDAPI) => api.apiId === selectedApiEvent.apiData.apiId) ;
        
        const newAddedApi = this.authApiChipOptions.toArray()[index];
        if(newAddedApi){
          console.log(newAddedApi);
          setTimeout(() => {
            this.apiChipOptions.toArray()[index].select();
          },200)
        }
      }
    })
  }

  async apisListSetter(){
    try {
      await this.apiconfigService.getAllApisResquest();
    } catch (error:any) {
      if(error?.status == 403) {
        this.toastrSrv.error('You do not have permission to access this resource.');
      }
      console.error('Failed to fetch APIs:', error);
      // Handle the error appropriately, e.g., show a user notification
    }
    this.apiconfigService.userApis$.subscribe((userApis) => {
      this.apis = userApis.apis;
      this.authApis = userApis.authTypeApis; 
    });
  }

  addApi(type:boolean){
    this.currentSelectedChip?.deselect();
    this.currentSelectedApi = null;
    this.apiconfigService.setSelectedApi({apiData:null,authApi:type,event:'click'});
  }

  selectedApi(event:any,api:any,type:boolean,chip?:any){
    this.currentSelectedChip = chip;
    if(!event.selected && event.isUserInput){
      chip.select();
    }
    if(event.selected && api.apiId !== this.currentSelectedApi?.apiId){
      this.currentSelectedApi = api;
      this.apiconfigService.setSelectedApi({apiData:api,authApi:type,event:'click'});
    }
  }

  panelSetter(type:boolean){
    this.currentSelectedChip?.deselect();
    this.apiconfigService.setSelectedApi({apiData:null,authApi:type,event:'click'});
  }
}
